import { render, staticRenderFns } from "./ParticaAccountBase.vue?vue&type=template&id=bb515498&"
import script from "./ParticaAccountBase.vue?vue&type=script&lang=ts&"
export * from "./ParticaAccountBase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports